import type { LayoutType } from '../../types';

class Elements {
  showForecastDetail(data: LayoutType) {
    return data === 'detailedForecast';
  }

  showForecast(data: LayoutType) {
    return data === 'detailedForecast' || data === 'hourlyForecast';
  }

  showDaily(data: LayoutType) {
    return data === 'detailedForecast' || data === 'dailyForecast';
  }

  showWidgetText(data: LayoutType) {
    return data !== 'currentTemperature';
  }
}

export const elements = new Elements();
